import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { Grid } from '@material-ui/core';
import { FieldsNoSpace } from './components/FieldsNoSpace';

/**
 * Field for displaying a label with multiple changing data points, i.e.
 * Something: {changingData} recorded at {date}
 */
export const FieldMultiData = (_ref) => {
  let {
    labelDataTuples,
    classes = {},
    gridProps
  } = _ref,
      props = _objectWithoutProperties(_ref, ["labelDataTuples", "classes", "gridProps"]);

  return /*#__PURE__*/React.createElement(Grid, _extends({
    item: true,
    xs: 12
  }, gridProps), labelDataTuples.map(([label, data], i) => /*#__PURE__*/React.createElement(FieldsNoSpace, _extends({
    key: `${label}-${data}`,
    classes: classes,
    label: label,
    data: data,
    i: i
  }, props))));
};